import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="trips--segments"
// Manages trip segment lifecycle: adding, removing, and ordering
export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.index = this.containerTarget.querySelectorAll(".segment-card").length
  }

  addSegment(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.containerTarget.insertAdjacentHTML("beforeend", content)

    // Update position for the new segment
    this.#updatePositions()

    // Remove "no segments" message if present
    const noSegmentsMsg = this.element.querySelector(".text-muted.text-center")
    if (noSegmentsMsg) {
      noSegmentsMsg.remove()
    }
  }

  removeSegment(event) {
    event.preventDefault()

    const segmentCard = event.target.closest(".segment-card")
    if (!segmentCard) return

    // Find the destroy input for this segment
    const destroyInput = segmentCard.querySelector('input[name*="_destroy"]')
    if (destroyInput) {
      destroyInput.value = "true"
    }

    // Hide the segment card
    segmentCard.classList.add("d-none")

    // Update positions for remaining visible segments
    this.#updatePositions()
  }

  toggleVehicleFields(event) {
    const segmentCard = event.target.closest(".segment-card")
    if (!segmentCard) return

    const vehicleFields = segmentCard.querySelectorAll(".vehicle-fields")
    const transportType = event.target.value

    // Show vehicle fields only for private_vehicle and company_car
    const showVehicle = transportType === "private_vehicle" || transportType === "company_car"

    vehicleFields.forEach((field) => {
      field.style.display = showVehicle ? "" : "none"
    })
  }

  toggleForeignFields(event) {
    const countryCodeField = document.getElementById("country_code_field")
    if (!countryCodeField) return

    const tripType = event.target.value
    countryCodeField.style.display = tripType === "foreign" ? "" : "none"
  }

  #updatePositions() {
    const visibleSegments = this.containerTarget.querySelectorAll(".segment-card:not(.d-none)")
    visibleSegments.forEach((segment, index) => {
      const positionInput = segment.querySelector('input[name*="[position]"]')
      if (positionInput) {
        positionInput.value = index
      }
    })
  }
}
